module.exports = __webpack_public_path__ + "img/register-v2.618df011.svg";